import request from '@/utils/request'
import qs from 'qs'

export function xcVehicleLoan(params) {
    return request({
        url: "/api/xcVehicleLoan" + "?" + qs.stringify(params, { indices: false }),
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/carLoanCustomers.js